<ng-container *transloco="let t">
  <div class="dense-3">
    <mat-form-field>
      <span matPrefix><mat-icon>search</mat-icon></span>

      <input
        #elementInput
        type="text"
        matInput
        [placeholder]="
          t(
            mode === ActivityBarPillTypeEnum.DATA_SOURCE
              ? 'widgets.change-data-source'
              : mode === ActivityBarPillTypeEnum.COMPARISON
                ? 'dashboard-pill.change-comparison'
                : 'dashboard-pill.change-widget-group'
          )
        "
        [formControl]="inputAc.control"
        [(ngModel)]="selectedEntity"
        [matAutocomplete]="elementSelectedEntity"
        (input)="updateEntities()"
        (blur)="resetEntity()"
      />

      <mat-autocomplete
        #elementSelectedEntity="matAutocomplete"
        (optionSelected)="selectEntity($event.option.value)"
        [panelWidth]="'450px'"
      >
        @for (item of inputAc.observable | async; track item) {
          <div
            [matTooltip]="entityProps[item?.value?.id]?.tooltip || entityProps[item?.id]?.tooltip"
          >
            <mat-option
              [value]="item"
              [disabled]="entityProps[item?.value?.id]?.disabled || entityProps[item?.id]?.disabled"
              (mousedown)="$event.preventDefault()"
              [class.picker-option--selected]="
                value === item?.value || value?.id === item?.id || value?.id === item?.value?.id
              "
            >
              <div class="picker-option">
                <div class="icon-wrapper">
                  <xi-icon
                    [icon]="
                      iconFor(mode === ActivityBarPillTypeEnum.DATA_SOURCE ? item?.value : item)
                    "
                    iconSize="medium"
                  ></xi-icon>
                  @if (
                    mode === ActivityBarPillTypeEnum.DATA_SOURCE && item?.value?.isDriverAnalysis
                  ) {
                    <div class="aux-icon-wrapper">
                      <xi-icon icon="impact_analysis" iconSize="small" color="success"></xi-icon>
                    </div>
                  }
                </div>
                <ng-container
                  *ngTemplateOutlet="
                    mode === ActivityBarPillTypeEnum.DATA_SOURCE
                      ? dsOptionTemplate
                      : compOptionTemplate;
                    context: { $implicit: item }
                  "
                ></ng-container>
                <ng-template #dsOptionTemplate let-item>
                  {{ item.display | truncate: 30 }} |
                  <small>
                    {{
                      t('widgets.numberof-docs', {
                        count: (item.value.documentCount | humanizeInt: 1 : 1000),
                      })
                    }}
                  </small>
                </ng-template>
                <ng-template #compOptionTemplate let-item>
                  {{ item?.title | truncate: 30 }}
                </ng-template>
                @if (
                  value === item?.value || value?.id === item?.id || value?.id === item?.value?.id
                ) {
                  <xi-icon
                    class="picker-option__selected-icon"
                    icon="circle_check_filled"
                    color="CX"
                  ></xi-icon>
                }
              </div>
            </mat-option>
          </div>
        }
      </mat-autocomplete>

      <button
        matSuffix
        mat-icon-button
        (mousedown)="$event.preventDefault()"
        (click)="clearSelectedEntity()"
        class="data-source-chooser__clear-search"
      >
        <xi-icon icon="cancel" iconSize="small"></xi-icon>
      </button>

      @if (inputAc.inProgress) {
        <mat-spinner matSuffix diameter="24"></mat-spinner>
      }
    </mat-form-field>
  </div>
</ng-container>
